import request from '@/utils/request'

export function getPromotionByParam(param) {
  return request({
    url: `/adusage/${param}`,
    method: 'GET'
  })
}


// WEBPACK FOOTER //
// ./src/api/promotion.js